import React from 'react'

import AdvertListPage from '../../screens/AdvertsListPage/AdvertsListPage.component'

const Adverts: React.FC = () => {
  return (
    <AdvertListPage />
  )
}

export default Adverts
